import React, { useState ,useEffect} from 'react';
import { TextBox, Button } from 'devextreme-react';
import '../dataentry/css/PopupShippingForm.css';
import { connect } from "react-redux";
import axios from "axios";
import notify from 'devextreme/ui/notify';
import { getApiErrorMessage } from '../../../../common/concurrency';
const PopupShippingForm = (props) => {
    var accessToken = props.oidc.user.access_token;
    const handleSubmit = () => {
        console.log('Form Submitted:', props.formData);
        UpdateShippingInfo(props.formData);
        props.onClose();
    };
    const createRow = (label, carrierField, junctionField) => (
        <tr>
            <td>
                <TextBox
                    value={props.formData[carrierField]}
                    onValueChanged={(e) =>
                        props.setFormData({ ...props.formData, [carrierField]: e.value })
                    }
                    label={`${label} Carrier`}
                    labelMode="static"
                    stylingMode="outlined"
                />
            </td>
            <td>
                <TextBox
                    value={props.formData[junctionField]}
                    onValueChanged={(e) =>
                        props.setFormData({ ...props.formData, [junctionField]: e.value })
                    }
                    label={`${label} Junction`}
                    labelMode="static"
                    stylingMode="outlined"
                    disabled={label ==='6th'}
                />
            </td>
        </tr>
    );

    const UpdateShippingInfo = async (formData) => {
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/UpdateShippingInfo`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken
                    }
                }
            );
    
            console.log('Update successful:', response.data);
            notify(
                {
                    message: "Shipping information updated successfully!",
                    width: 600,
                },
                'success',
                3000,
            );
        } catch (error) {
            console.error('Update failed:', error);
            // Until UpdateShippingInfo answered a real status, a failed update returned 200 carrying the
            // *success* message, so this catch never ran and the user was told the save had worked.
            notify(
                {
                    message: getApiErrorMessage(error, 'Failed to update shipping information.'),
                    width: 100,
                },
                'error',
                3000,
            );
        }
    };
    
    if (!props.isOpen) return null;
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div className="modal-overlay">
                        <div className="shipping-form popup">
                            <div className="title">
                                <h6 style={{ color: window._env_.Color2, marginLeft: '16px' }}>
                                    Shipping Information
                                </h6>
                            </div>
                            <div className="row accordianLastRow">
                                <div className="col-md-12">
                                    <TextBox
                                        value={props.formData.quote}
                                        onValueChanged={(e) => props.setFormData({ ...props.formData, quote: e.value })}
                                        label="Quote #"
                                        labelMode="static"
                                        stylingMode="outlined"
                                    />
                                </div>
                            </div>

                            <div className="row accordianLastRow">
                                <div className="col-md-12">
                                    <TextBox
                                        value={props.formData.route}
                                        onValueChanged={(e) => props.setFormData({ ...props.formData, route: e.value })}
                                        label="Route Info"
                                        labelMode="static"
                                        stylingMode="outlined"
                                    />
                                </div>
                            </div>

                            <div className="row accordianLastRow">
                                <div className="col-md-12">
                                    <table className="stops-table">
                                        <thead>
                                            <tr>
                                                <th>Carrier SCAC</th>
                                                <th>Junction Code</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {createRow('Origin', 'originCarrier', 'originJunction')}
                                            {createRow('2nd', 'secondCarrier', 'secondJunction')}
                                            {createRow('3rd', 'thirdCarrier', 'thirdJunction')}
                                            {createRow('4th', 'fourthCarrier', 'fourthJunction')}
                                            {createRow('5th', 'fifthCarrier', 'fifthJunction')}
                                            {createRow('6th', 'sixthCarrier', 'sixthJunction')}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row accordianLastRow">
                                <div className="col-md-12">
                                    <TextBox
                                        value={props.formData.comment}
                                        onValueChanged={(e) => props.setFormData({ ...props.formData, comment: e.value })}
                                        label="Comment"
                                        labelMode="static"
                                        stylingMode="outlined"
                                        mode="text"
                                        height={80}
                                        multiline={true}
                                    />
                                </div>
                            </div>

                            <div className="row accordianLastRow">
                                <div className="col-md-12">
                                    <div className="form-buttons">
                                        <Button text="Save & Exit" onClick={handleSubmit} type="default" />
                                        <Button text="Cancel" onClick={props.onClose} style={{marginLeft:'20px'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PopupShippingForm);
 
